import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 18,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_29_3078)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.99992 1.5C8.46017 1.5 8.83325 1.8731 8.83325 2.33333C8.83325 2.76069 8.51156 3.11292 8.09711 3.16106L7.99992 3.16667H3.83325C3.40589 3.16667 3.05366 3.48837 3.00552 3.90282L2.99992 4V14C2.99992 14.4274 3.32162 14.7796 3.73607 14.8277L3.83325 14.8333H7.58325C8.0435 14.8333 8.41659 15.2064 8.41659 15.6667C8.41659 16.094 8.0949 16.4463 7.68044 16.4944L7.58325 16.5H3.83325C2.50185 16.5 1.41353 15.4593 1.3375 14.1469L1.33325 14V4C1.33325 2.6686 2.37402 1.58028 3.68636 1.50424L3.83325 1.5H7.99992ZM12.7558 6.05372L15.1128 8.41075C15.4383 8.73617 15.4383 9.26383 15.1128 9.58925L12.7558 11.9462C12.4303 12.2717 11.9028 12.2717 11.5773 11.9462C11.2518 11.6208 11.2518 11.0932 11.5773 10.7677L12.5118 9.83333H7.99992C7.53967 9.83333 7.16659 9.46025 7.16659 9C7.16659 8.53975 7.53967 8.16667 7.99992 8.16667H12.5118L11.5773 7.23223C11.2518 6.9068 11.2518 6.37916 11.5773 6.05372C11.9028 5.72828 12.4303 5.72828 12.7558 6.05372Z",
			fill: "#424242"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_3078",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgLogout;
